module.exports = __webpack_public_path__ + "static/media/add-cover-photo.b300ea8a.svg";